module.exports = __webpack_public_path__ + "static/media/product-3.d27ec2bc.png";